import { FormControl } from '@angular/forms';

export let CONSTANTES = {
    //PRE
    //api_url: 'http://localhost:8088/pcami/services',
    //api_url: 'http://192.168.2.2:25443/pcami/services',
    //api_url: 'http://localhost:25443/pcami/services',
    //PRO
    api_url: 'https://pspopcami.es:443/pcami/services',
    version: '1.0.0',
    //menu: "../../../../../assets/menu.js",
    //imagenesLogin: "../../../../../assets/img",
    //logoDefensa: "../assets/img/main-images/logo_defensa.png",
    //navBarImage: "../../../../../assets/img/main-images/LoginIcono.png",
    //menuImage: "./assets/img/main-images/menu.png",
    //mensajeHome: "./assets/img/messages/",
    //pdf: "../../../../../assets/pdf/"
    menu: "assets/menu.js",
    imagenesLogin: "assets/img",
    logoDefensa: "assets/img/main-images/logo_defensa.png",
    navBarImage: "assets/img/main-images/LoginIcono.png",
    menuImage: "assets/img/main-images/menu.png",
    homeImage: "assets/img/main-images/mensaje.png",
    mensajeHome: "assets/img/messages/",
    pdf: "assets/pdf/",
    //PRE
    //imagesUrl: "http://10.0.0.103/images",
    //pdfUrl: "http://10.0.0.103/pdf",
    //pasadoresUrl: "http://localhost/pcami/images/pasadores/"
    //PRO
    imagesUrl: "http://www.pspopcami.es:80/images",
    pdfUrl: "http://www.pspopcami.es:80/pdf",
    pasadoresUrl: "http://www.pspopcami.es:80/images/"

}

export function translateStatus(data: any) {
    if(data === 'FINISHED'){
        data = 'FINALIZADO'
    }
    else if (data === 'CANCELLED'){
        data = 'CANCELADO'
    }
    else if (data === 'CONFIRMED'){
        data = 'CONFIRMADO'
    }
    else if (data === 'SAVED'){
        data = 'AUTORIZANDO'
    }
}


export function getToken(data: any) {

    if (data != null && data.token != null) {
        localStorage.setItem("token", data.token);
        return true;
    }
    return false;
}

export function checkError(code: string) {
    if (code === "E_SECURITY_ACCESS_GLOBAL" || code === "E_SECURITY_EXPIRED_SESSION") {
        return false;
    }

    return true;
}
export interface ValidationResult {
    [key: string]: boolean;
}

export class PasswordValidator {

    public static strong(control: FormControl): ValidationResult {
        let hasNumber = /\d/.test(control.value);
        let hasUpper = /[A-Z]/.test(control.value);
        let hasLower = /[a-z]/.test(control.value);
        let hasCharacter = /[^\w\s]/.test(control.value);
        let length = control.value.length;
        const valid = hasNumber && hasUpper && hasLower && hasCharacter && (length > 6);
        if (!valid) {
            return { strong: true };
        }
        return null;
    }
}

export function zeroFill(number, width) {
    width -= number.toString().length;
    if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
    }
    return number + ""; // siempre devuelve tipo cadena
}
